export const DragIcon = () => {
    return (
        <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1 1L10.4151 0.999999" stroke="#8796AB" stroke-width="2" stroke-linecap="round" />
            <path d="M1 5.95703L10.4151 5.95703" stroke="#8796AB" stroke-width="2" stroke-linecap="round" />
            <path d="M1 11L10.4151 11" stroke="#8796AB" stroke-width="2" stroke-linecap="round" />
        </svg>
    )
}